/*
 * Geo Header Controller — Phases 3, 5, 6, 7.
 * Resolution priority: ?geo_test= override > cached profile > GeoIP resolver (Phase 6, calls
 * ipapi.co directly from the browser) > default. Any failure at any step falls through to the
 * next step, and the server-rendered default markup is left untouched unless a real value is
 * available to apply.
 *
 * NOTE: IPAPI_KEY below is embedded in this file by design (client-side lookup, no backend) —
 * it is publicly visible to anyone who views source or the Network tab. If lookup volume/cost
 * looks off, check ipapi.co's dashboard for a domain/referrer restriction option for the key.
 *
 * Updates every element carrying:
 *   data-geo-phone          (phone display text)
 *   data-geo-phone-href     (tel: link href)
 *   data-geo-contact-url    (Contact Us link href)
 *   data-geo-showroom-link  (Showroom nav link href — untouched for the default region)
 *   data-geo-showroom-label (Showroom nav link text — untouched for the default region)
 */
(function () {
  if (window.GeoHeaderController) return;
  window.GeoHeaderController = true;

  var PROFILES = window.GeoHeaderProfiles || {};
  var VALID_REGIONS = window.GeoHeaderRegionPriority || ['default'];
  var IPAPI_KEY = 'D1If1TtForaL6xiBUht1LrlRQGMEK66lXeb2JhByuZ0IZXA7sI';
  var CACHE_KEY = 'tmb_geo_header_region';
  var CACHE_TTL_MS = 24 * 60 * 60 * 1000; // 24h — long enough to survive a browsing session, short enough for a traveling visitor
  // FL/VA visitors trigger a second network call (county lookup) after the ipapi.co call, so
  // this needs more headroom than a single round trip.
  var RESOLVER_TIMEOUT_MS = 3000;

  function isPlaceholder(value) {
    return value == null || value === '' || /^(TBD|VERIFY)$/i.test(String(value).trim());
  }

  function resolveField(regionKey, field) {
    var profile = PROFILES[regionKey] || PROFILES.default || {};
    var value = profile[field];
    if (isPlaceholder(value)) {
      value = (PROFILES.default || {})[field];
    }
    return isPlaceholder(value) ? null : value;
  }

  function getTestOverride() {
    var params = new URLSearchParams(window.location.search);
    var raw = params.get('geo_test');
    if (!raw) return null;
    var key = raw.trim().toLowerCase();
    return VALID_REGIONS.indexOf(key) > -1 ? key : null;
  }

  function getCachedRegion() {
    try {
      var raw = window.localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || typeof data.region !== 'string' || typeof data.expires !== 'number') return null;
      if (Date.now() > data.expires) return null;
      return VALID_REGIONS.indexOf(data.region) > -1 ? data.region : null;
    } catch (e) {
      return null;
    }
  }

  function setCachedRegion(region) {
    try {
      window.localStorage.setItem(CACHE_KEY, JSON.stringify({
        region: region,
        expires: Date.now() + CACHE_TTL_MS
      }));
    } catch (e) {
      // localStorage unavailable (private browsing, quota) — resolve fresh every load instead.
    }
  }

  // QA helper: run `GeoHeaderClearCache()` in the console to force a fresh resolve.
  window.GeoHeaderClearCache = function () {
    try { window.localStorage.removeItem(CACHE_KEY); } catch (e) {}
  };

  function showTestBadge(region) {
    if (document.getElementById('geo-header-test-badge')) return;
    var badge = document.createElement('div');
    badge.id = 'geo-header-test-badge';
    badge.textContent = 'GEO TEST: ' + region.toUpperCase();
    badge.style.cssText = [
      'position:fixed', 'bottom:8px', 'right:8px', 'z-index:2147483647',
      'background:#111', 'color:#fff', 'font:600 11px/1 monospace',
      'padding:6px 10px', 'border-radius:4px', 'opacity:0.85', 'pointer-events:none'
    ].join(';');
    document.body.appendChild(badge);
  }

  // Phase 9 — territory matching.
  //
  // State-level and radius regions match directly off ipapi.co's region_code/lat/lng — no
  // extra network call. County-level regions (FL, VA) need one more call, since ipapi.co
  // doesn't return county: the FCC's public Census Area API resolves county from lat/lng
  // (free, no key). That call's CORS behavior for browser requests hasn't been verified live
  // yet — worth checking during QA. Either way it fails safe to null (-> default) like
  // everything else here.

  // CO (Denver) intentionally has no entry — store owner has not yet confirmed the actual
  // coverage area ("entire state of Denver" isn't a real place; asked twice, no answer yet).
  var STATE_REGION_MAP = {
    GA: 'atlanta',
    WA: 'seattle', // "Kent, WA" showroom — kept the existing `seattle` profile key for continuity
    MD: 'columbia',
    DE: 'columbia',
    DC: 'columbia'
  };

  var RADIUS_REGIONS = [
    { region: 'houston', lat: 29.7604, lng: -95.3698, miles: 100 },
    { region: 'gardena', lat: 34.0522, lng: -118.2437, miles: 100 }
  ];

  // Bare county/city names — normalizeCountyName() strips "County"/"city" from both sides
  // before comparing, so exact suffix formatting from the FCC lookup doesn't matter.
  var COUNTY_REGIONS_BY_STATE = {
    FL: [
      // Only 6 of the 7 requested counties: the store owner's list included "Port Charlotte
      // County", which isn't a real FL county name. Asked twice for the real name, no answer
      // yet — omitted rather than guessed.
      { region: 'sarasota', counties: ['Sarasota', 'Hillsborough', 'Manatee', 'Collier', 'Lee', 'Pinellas'] },
      // Standard Orlando MSA definition, used as a starting point (store owner OK'd this
      // approach in lieu of sending their own list) — not yet confirmed against a client list.
      { region: 'orlando', counties: ['Orange', 'Seminole', 'Osceola', 'Lake', 'Volusia'] }
    ],
    VA: [
      // Standard Northern Virginia definition, same starting-point basis as Orlando above.
      { region: 'columbia', counties: ['Arlington', 'Fairfax', 'Loudoun', 'Prince William', 'Alexandria', 'Falls Church', 'Manassas', 'Manassas Park'] }
    ]
  };

  function toRad(deg) {
    return deg * Math.PI / 180;
  }

  function haversineMiles(lat1, lng1, lat2, lng2) {
    var EARTH_RADIUS_MILES = 3958.8;
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return EARTH_RADIUS_MILES * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function normalizeCountyName(name) {
    return String(name || '').trim().toLowerCase().replace(/\s+(county|city|parish)$/i, '');
  }

  function lookupCountyName(lat, lng) {
    var url = 'https://geo.fcc.gov/api/census/area?lat=' + lat + '&lon=' + lng + '&format=json';
    return fetch(url, { signal: AbortSignal.timeout(2000) })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        var result = data && data.results && data.results[0];
        return result ? normalizeCountyName(result.county_name) : null;
      })
      .catch(function () { return null; });
  }

  function matchByCounty(location, rules) {
    return lookupCountyName(location.lat, location.lng).then(function (county) {
      if (!county) return null;
      for (var i = 0; i < rules.length; i++) {
        var normalized = rules[i].counties.map(normalizeCountyName);
        if (normalized.indexOf(county) > -1) return rules[i].region;
      }
      return null;
    });
  }

  function matchTerritory(location) {
    if (!location || typeof location.lat !== 'number' || typeof location.lng !== 'number') {
      return Promise.resolve(null);
    }

    var byState = STATE_REGION_MAP[location.regionCode];
    if (byState) return Promise.resolve(byState);

    var countyRules = COUNTY_REGIONS_BY_STATE[location.regionCode];
    if (countyRules) return matchByCounty(location, countyRules);

    for (var i = 0; i < RADIUS_REGIONS.length; i++) {
      var radiusRegion = RADIUS_REGIONS[i];
      if (haversineMiles(location.lat, location.lng, radiusRegion.lat, radiusRegion.lng) <= radiusRegion.miles) {
        return Promise.resolve(radiusRegion.region);
      }
    }

    return Promise.resolve(null);
  }

  function resolveRegionFromGeoIP() {
    return fetch('https://ipapi.co/json/?key=' + IPAPI_KEY)
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || data.error) return null;
        var location = {
          city: data.city || null,
          regionCode: data.region_code || null,
          postal: data.postal || null,
          country: data.country_code || null,
          lat: typeof data.latitude === 'number' ? data.latitude : null,
          lng: typeof data.longitude === 'number' ? data.longitude : null
        };
        return matchTerritory(location);
      })
      .catch(function () { return null; });
  }

  function resolveRegion() {
    var testOverride = getTestOverride();
    if (testOverride) {
      showTestBadge(testOverride);
      return Promise.resolve(testOverride);
    }

    var cached = getCachedRegion();
    if (cached) return Promise.resolve(cached);

    return Promise.race([
      resolveRegionFromGeoIP(),
      new Promise(function (resolve) {
        setTimeout(function () { resolve(null); }, RESOLVER_TIMEOUT_MS);
      })
    ]).then(function (resolved) {
      if (resolved && VALID_REGIONS.indexOf(resolved) > -1) {
        setCachedRegion(resolved);
        return resolved;
      }
      return 'default';
    }).catch(function () {
      return 'default';
    });
  }

  function applyProfile(regionKey) {
    try {
      var phoneDisplay = resolveField(regionKey, 'phoneDisplay');
      var phoneHref = resolveField(regionKey, 'phoneHref');
      var contactUrl = resolveField(regionKey, 'contactUrl');
      // Default region keeps whatever Showroom destination/label is already in the nav —
      // geo targeting only redirects it for the named regional profiles.
      var showroomUrl = regionKey !== 'default' ? resolveField(regionKey, 'showroomUrl') : null;
      var showroomLabel = regionKey !== 'default' ? resolveField(regionKey, 'showroomLabel') : null;

      if (phoneDisplay) {
        document.querySelectorAll('[data-geo-phone]').forEach(function (el) {
          el.textContent = phoneDisplay;
        });
      }
      if (phoneHref) {
        document.querySelectorAll('[data-geo-phone-href]').forEach(function (el) {
          el.setAttribute('href', phoneHref);
        });
      }
      if (contactUrl) {
        document.querySelectorAll('[data-geo-contact-url]').forEach(function (el) {
          el.setAttribute('href', contactUrl);
        });
      }
      if (showroomUrl) {
        document.querySelectorAll('[data-geo-showroom-link]').forEach(function (el) {
          el.setAttribute('href', showroomUrl);
        });
      }
      if (showroomLabel) {
        document.querySelectorAll('[data-geo-showroom-label]').forEach(function (el) {
          el.textContent = showroomLabel;
        });
      }
    } catch (e) {
      console.error('[GeoHeader] Failed to apply profile, leaving current header values in place:', e);
    }
  }

  function init() {
    resolveRegion().then(applyProfile);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-apply after Shopify theme-editor section reloads, since hooked elements get re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
